<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.ceramicFilterParaRecord')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/ceramicFilterParaRecord">
              <span>{{$t('tlt.ceramicFilterParaRecord')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{ $t("lbl.basic.startTime") }} :</label>
                  <mmf-datetimepicker v-model="startTimeFilter"></mmf-datetimepicker>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{ $t("lbl.basic.endTime") }} :</label>
                  <mmf-datetimepicker v-model="endTimeFilter"></mmf-datetimepicker>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">
                    <span class="lbl-required"></span>
                    {{$t('lbl.cfp.pelletizing')}}:
                  </label>
                  <select class="form-control" type="text" v-model="locNameFilter">
                    <option value="default">{{ $t("lbl.basic.select.one") }}</option>
                    <option value="球团车间一期">{{$t('lbl.basic.plant.pelletizing1')}}</option>
                    <option value="球团车间二期">{{$t('lbl.basic.plant.pelletizing2')}}</option>
                    <option value="球团车间三期">{{$t('lbl.basic.plant.pelletizing3')}}</option>
                  </select>
                </div>
                <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="MMFClearFilter('ceramicFilterPara')"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-on:click="MMFLoadRows('ceramicFilterPara')"
                    >
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div id="ceramicFilterParaRecordTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <b-table :items="items" :fields="fields" class="table table-striped table-hover"></b-table>
              <mmf-table entity="ceramicFilterPara" inline-actions-enabled singleChoice disableInlineView></mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  gridFields,
  filterFields
} from "@/model/prd/productionExecution/pelletizing/CeramicFilterPara";
import MmfTable from "@/components/MmfTable";
import MmfDatetimepicker from "@/components/MmfDatetimepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "ceramicFilterPara/getField",
  mutationType: "ceramicFilterPara/updateField"
});

export default {
  name: "ceramicFilterParaRecord",
  data() {
    return {
      //  checkedItems: []
      dataFields:[
        {
            key: 'current',
            label: "电流 A",
            sortable: true
        },
        {
            key: 'grAindingVol',
            label: '磨矿量 t/h',
            sortable: true
        },
        {
            key: 'waterSupply',
            label: '给水量 m3/h',
            sortable: true
        },
        {
            key: 'concentration',
            label: '浓度 %',
            sortable: true
        },
        {
            key: 'granularity',
            label: '粒度 -200目%',
            sortable: true
        },
        {
            key: 'steelBall',
            label: '加钢球 Kg',
            sortable: true
        },
        {
            key: 'filterCakeWater1',
            label: '1#滤饼水分',
            sortable: true
        },
        {
            key: 'filterCakeWater2',
            label: '2#滤饼水分',
            sortable: true
        },
        {
            key: 'filterCakeWater3',
            label: '3#滤饼水分',
            sortable: true
        },
        {
            key: 'filterCakeWater4',
            label: '4#滤饼水分',
            sortable: true
        },
        {
            key: 'filterCakeWater301',
            label: 'CV301水分',
            sortable: true
        },
        {
            key: 'slurryFixedCarbon',
            label: '矿浆固定碳 %',
            sortable: true
        },
        {
            key: 'pulpCaContent',
            label: '矿浆钙含量 %',
            sortable: true
        },
        {
            key: 'stronglyMixedWater',
            label: '强混水分 %',
            sortable: true
        },
        {
            key: 'rawBallCarbon',
            label: '生球固定碳 %',
            sortable: true
        },
        {
            key: 'rawBallDropStrength',
            label: '生球落下强度 次/0.5m',
            sortable: true
        },
        {
            key: 'ripeBallStrength',
            label: '熟球强度 N',
            sortable: true
        },
        {
            key: 'conversionIndex',
            label: '转股指数 %',
            sortable: true
        },
        {
            key: 'abrasionIndex',
            label: '抗磨指数 %',
            sortable: true
        },
        {
            key: 'so2',
            label: 'SO2',
            sortable: true
        },
        {
            key: 'nox',
            label: 'NOx',
            sortable: true
        },
        {
            key: 'pm',
            label: '颗粒物',
            sortable: true
        },
      ],
    };
  },
  components: { MmfTable, MmfDatetimepicker },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.ceramicFilterPara.rows,
      tableColumns: gridFields,
      entity: state => state.ceramicFilterPara.entity,
      checkedItems: state => state.ceramicFilterPara.checkedItems,
      showNoResultAlert: state => state.base.showNoResultAlert
    }),
    nanTag(){
      return '_'
    },
    items() {
      let average = new Array(this.dayAverage(),this.earlyAverage(),this.lateAverage());
      return average
    },
    fields(){
      return [
        {
            key: 'average',
            label: '平均值',
            sortable: true
        },
        ...this.dataFields
      ]
    } ,
    fieldsKey(){
      return this.dataFields.map(v=>v.key)
    }
  },
  methods: {
    ...mapActions("base", [
      "MMFselectRow",
      "MMFselectAllRows",
      "MMFNew",
      "MMFEdit",
      "MMFLoadRows",
      "MMFDelete",
      "MMFClearFilter"
    ]),
    average(init, filter= ()=>true) {
      let rows = this.rows.filter(filter);
      let total = this.fieldsKey.reduce(
        (prev, key) => {
          let value = this.calcAverage(rows.map(v => Number.parseFloat(v[key])).filter(v => !isNaN(v))).toFixed(2);
          prev[key] = isNaN(value)?this.nanTag:value;
          return prev;
        },
        init
      );
      return total;
    },
    dayAverage() {
      return this.average({average: "日平均"});
    },
    earlyAverage() {
      return this.average({ average: "早班平均" }, this.findEarlyRow);
    },
    lateAverage() {
      return this.average({ average: "晚班平均" }, v => !this.findEarlyRow(v))
    },
    findEarlyRow(row) {
      const date = new Date(row['recTime']);
      const hour = date.getHours();
      return hour >= 9 && hour <= 19;
    },
    calcAverage(arr) {
      return arr.reduce((s, v) => s + v, 0) / arr.length
    }
  },
  mounted() {}
};
</script>